module.exports = __webpack_public_path__ + "img/6-Pivot-Columns.dce088ef.png";